import { normalizeTableRows } from "./normalizeTableRows";
import { TABLE_PAGE_SIZE } from "./tablePaginationUtils";

/**
 * Apply sorted table rows from POST /api/query/execute-sql to inline table,
 * pagination, and full-view modal state.
 */
export function applyTableSortResult({
  response,
  msgIndex,
  tableKey,
  referenceRows = null,
  fullViewReferenceRows = null,
  setRows,
  setTablePagination,
  setFullViewTable,
}) {
  if (!response?.success || !Array.isArray(response.data)) {
    return { ok: false };
  }

  const sortedRows = response.data;
  const normalizedSorted = normalizeTableRows(sortedRows, referenceRows);
  const loadedCount = normalizedSorted.length;
  const totalCount =
    response.total_count ??
    response.totalCount ??
    response.row_count ??
    response.rowCount ??
    loadedCount;
  const pageSize = response.page_size ?? response.pageSize ?? TABLE_PAGE_SIZE;
  const hasMore =
    response.has_more ??
    response.hasMore ??
    (totalCount != null ? loadedCount < totalCount : loadedCount >= pageSize);

  const sortedSql = response.sorted_sql ?? response.sortedSql ?? null;

  setRows((prev) => {
    if (!prev[msgIndex]) return prev;
    const updated = [...prev];
    updated[msgIndex] = {
      ...updated[msgIndex],
      rawResults: normalizedSorted,
      totalCount,
      sortedSql,
    };
    return updated;
  });

  setTablePagination((prev) => ({
    ...prev,
    [tableKey]: {
      ...prev[tableKey],
      loadedCount,
      totalCount,
      hasMore,
      offset: loadedCount,
    },
  }));

  setFullViewTable((fv) => {
    if (fv?.tableKey !== tableKey) return fv;
    const ref =
      fullViewReferenceRows?.length > 0
        ? fullViewReferenceRows
        : fv.data?.length
          ? fv.data
          : referenceRows;
    const modalRows = normalizeTableRows(sortedRows, ref);
    return {
      ...fv,
      data: modalRows,
      columns: fv.columns?.length ? fv.columns : response.columns?.length ? response.columns : fv.columns,
      totalCount,
      hasMore,
      sqlQuery: sortedSql ?? fv.sqlQuery,
    };
  });

  return { ok: true, sortedSql, totalCount, hasMore, loadedCount, rows: normalizedSorted };
}
